import { resolveIcon } from '../../styles/icons'
import useTranslation from "../../hooks/useTranslation"
import styled from "styled-components"
import { renderCardGroups } from "./common"
import RButton from "../generic/RButton"

const IconCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background: ${({ theme }) => theme?.btn?.primary || '#007bff'};
    color: #fff;
    flex-shrink: 0;

    svg {
        width: 1rem;
        height: 1rem;
    }
`

const LineCard = styled.div`
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: start;
    background: ${({ theme }) => theme?.card?.bg2 || 'rgba(245,246,249,1)'};
    border-radius: 12px;
    box-shadow: ${({ theme }) => theme?.card?.boxShadow || '0 2px 8px rgba(0, 0, 0, 0.1)'};
    padding: 0.75rem;
    gap: 0.75rem;
`

const LineCardContent = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: start;
    gap: 0.5rem;
`

const LineCardActions = styled.div`
    display: flex;
    align-items: start;
`



const DetailViewLinesCard = ({ config, item, line, onAction }) => {
    const { t } = useTranslation()

    if (!config || !item) return null

    const linesArray = item[config.array] || []
    if (linesArray.length === 0) return null
    let lineIndex = 0

    const variant = line.type
    console.log('variant', variant)
    const variantConfig = config.variants?.[variant]

    const lineGroups = variantConfig?.group || config.group || []
    const lineIcon = resolveIcon(variantConfig?.icon || config.icon)
    const actions = variantConfig?.actions || config.actions || []

    return (
        <LineCard key={line.id || lineIndex}>
            {lineIcon && (
                <IconCircle>
                    {lineIcon}
                </IconCircle>
            )}
            <LineCardContent>
                {renderCardGroups(lineGroups, line, t)}
            </LineCardContent>
            {actions.length > 0 && (
                <LineCardActions>
                    {actions.map((action, actionIndex) => (
                        <RButton
                            key={actionIndex}
                            label={action.label}
                            icon={action.icon}
                            $variant="secondary"
                            $shadow={false}
                            onClick={() => onAction && onAction(action, item, line)}
                        />
                    ))}
                </LineCardActions>
            )}
        </LineCard>
    )
}

export default DetailViewLinesCard